// extracted by mini-css-extract-plugin
export default {"container":"nY-z","title":"oY-z","link":"pY-z"};